<div class="dialog-frame">

    <h2 mat-dialog-title class="title">{{ 'iplexGStartConnectDialogComponent.switchToOfflineConfirmationTitle' | translate }}</h2>

  <mat-dialog-content class="mat-typography guidance-message-content message-content">
    <p>{{ 'iplexGStartConnectDialogComponent.switchToOfflineConfirmationMessage1' | translate }}</p>
    <p>{{ 'iplexGStartConnectDialogComponent.switchToOfflineConfirmationMessage2' | translate }}</p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary">{{ 'iplexGStartConnectDialogComponent.cancelSwitchToOffline' | translate }}</button>
    <button mat-button color="primary" (click)="confirm()">{{ 'iplexGStartConnectDialogComponent.confirmSwitchToOffline' | translate }}</button>
  </mat-dialog-actions>
</div>
